export const siteInfo = {
  name: '每日爆料',
  slogan: '网红吃瓜吃料，一站看尽',
  tagline: '实时追踪网红圈最新动态',
  description: '每日爆料是专注网红圈内幕八卦的吃瓜平台，7×24 小时追踪全网网红最新动态。从直播翻车到人设崩塌，从恋爱绯闻到商务纠纷，从整容争议到黑料曝光——我们为你筛选最值得关注的网红吃料，不做假瓜、不炒冷饭，只做一手可验证的网红爆料合集。不管你吃瓜老手还是刚入圈，每日爆料都是你最靠谱的吃瓜入口。',
  stats: [
    { label: '日均更新', value: '50+' },
    { label: '追踪网红', value: '2000+' },
    { label: '爆料准确率', value: '92%' },
  ],
};

export const indexItems = [
  { id: 'idx-1', title: '娱乐圈八卦', desc: '明星与网红跨界互动、综艺争议、颁奖礼名场面合集', icon: 'ri-star-line', count: 128 },
  { id: 'idx-2', title: '网红黑料', desc: '人设崩塌实录、聊天记录曝光、税务与合约风波深度整理', icon: 'ri-spy-line', count: 96 },
  { id: 'idx-3', title: '直播翻车', desc: '带货口误、连线事故、技术灾难，直播间的尴尬瞬间归档', icon: 'ri-live-line', count: 74 },
  { id: 'idx-4', title: '恋爱绯闻', desc: '官宣、分手、隐婚、复合，网红感情线全梳理', icon: 'ri-heart-line', count: 89 },
  { id: 'idx-5', title: '商务纠纷', desc: '代言翻车、品牌解约、MCN 撕逼、合同争议复盘', icon: 'ri-briefcase-line', count: 53 },
  { id: 'idx-6', title: '整容争议', desc: '前后对比、医生爆料、神级变脸技术流分析', icon: 'ri-emotion-line', count: 41 },
  { id: 'idx-7', title: '人设崩塌', desc: '公益造假、学历翻车、炫富翻车等重大人设危机事件汇总', icon: 'ri-ghost-line', count: 67 },
];

export const aboutContent = {
  title: '关于每日爆料',
  paragraphs: [
    '每日爆料成立于 2023 年，是国内领先的网红圈吃瓜吃料聚合平台。我们秉持"真实、快速、全面"的原则，由一支深耕网红行业的资深编辑团队运营，每日产出原创爆料内容和深度分析。',
    '平台覆盖短视频、直播、电商带货、MCN 机构等全产业链，已收录超过 2000 位网红艺人的动态档案。每一篇爆料都经过多方信息交叉验证，标注信息来源和可信度等级，让吃瓜群众吃得放心、吃得明白。',
    '我们不是八卦制造机，而是网红行业的记录者和守望者。通过曝光不良行为，我们推动行业自律；通过梳理事件脉络，我们帮助公众理性吃瓜。每日爆料——网红圈吃瓜第一站。',
  ],
};

export const appContent = {
  title: '下载每日爆料 APP',
  subtitle: '随时随地吃最新鲜的瓜',
  desc: '每日爆料 APP 支持推送即时爆料通知、离线阅读、夜间模式、自定义关注网红等功能。iOS 与 Android 均已上架，扫码或点击下方按钮下载，从此不错过任何一个大瓜。',
  features: ['实时推送', '离线吃瓜', '夜间模式', '关注定制'],
  appImage: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20a%20news%20app%20interface%20with%20dark%20theme%2C%20warm%20red%20and%20amber%20accents%2C%20headlines%20layout%2C%20modern%20UI%20design%2C%20clean%20typography%2C%20no%20real%20text%20visible%2C%20abstract%20content%20blocks&width=400&height=533&seq=app-mockup-2025&orientation=portrait',
};

export const updatesItems = [
  { id: 'up-1', time: '3 分钟前', title: '某千万粉美食博主被曝食材造假', tag: '爆料', tagColor: 'primary' },
  { id: 'up-2', time: '28 分钟前', title: '头部 MCN 内部邮件泄露：将批量解约低效达人', tag: '内幕', tagColor: 'accent' },
  { id: 'up-3', time: '1 小时前', title: '两名顶流游戏主播线下冲突升级，互发律师函', tag: '纠纷', tagColor: 'primary' },
  { id: 'up-4', time: '2 小时前', title: '某美妆网红前员工爆料：测评产品全部为厂商定制版', tag: '黑料', tagColor: 'primary' },
  { id: 'up-5', time: '3 小时前', title: '直播带货新规出台，多位大主播连夜调整话术', tag: '政策', tagColor: 'secondary' },
  { id: 'up-6', time: '5 小时前', title: '情感网红被质疑剧本炒作，粉丝群内聊天记录流出', tag: '争议', tagColor: 'accent' },
  { id: 'up-7', time: '7 小时前', title: '某探店博主因恶意差评被商家联合起诉', tag: '法律', tagColor: 'secondary' },
  { id: 'up-8', time: '9 小时前', title: '跨平台网红迁移潮：抖音头部转战视频号背后原因', tag: '趋势', tagColor: 'accent' },
];

export const rankingItems = [
  { rank: 1, title: '顶流带货主播税务风波持续发酵', hot: '980万热度', change: 'up' },
  { rank: 2, title: '知名 MCN 被曝拖欠上百位达人分成', hot: '856万热度', change: 'up' },
  { rank: 3, title: '情感大 V 塌房：私下同时交往多名女粉', hot: '743万热度', change: 'new' },
  { rank: 4, title: '美妆一姐品牌被检出违禁成分', hot: '691万热度', change: 'up' },
  { rank: 5, title: '游戏圈两大工会线下约架警方介入', hot: '528万热度', change: 'down' },
  { rank: 6, title: '吃播网红浪费食物遭全网抵制', hot: '467万热度', change: 'new' },
];

export const commentsItems = [
  { id: 'cm-1', name: '吃瓜群众老王', avatar: '王', text: '这个平台整理得太清楚了！以前看八卦都是碎片化的，现在终于有一个地方能完整吃瓜了。特别喜欢时间线功能。', time: '2 天前', likes: 1283 },
  { id: 'cm-2', name: '互联网观察员', avatar: '观', text: '作为做了三年自媒体的从业者，这里的爆料信源标注做得比很多正规媒体都严谨。希望能一直保持这个水准，别被流量带偏。', time: '5 天前', likes: 967 },
  { id: 'cm-3', name: '默默吃瓜小号', avatar: '默', text: '闺蜜群里都在传这个站，每天上班摸鱼必刷。更新速度真的快，好几个事件我都是在别处看到之前就在这刷到了。', time: '1 周前', likes: 756 },
  { id: 'cm-4', name: '理性看热闹', avatar: '理', text: '这个平台有个很难得的地方：不站队、不带节奏，就是客观整理事实。在情绪化的互联网环境里，这种克制反而让人更愿意相信。', time: '2 周前', likes: 542 },
];

export const faqItems = [
  { id: 'faq-1', q: '每日爆料的爆料来源是什么？', a: '我们的爆料信息来自公开社交媒体、行业知情人士投稿、公开工商司法信息、以及编辑团队的独立调查。每条爆料均标注信息来源和可信度等级，确保读者可以自行判断。' },
  { id: 'faq-2', q: '如何向每日爆料投稿？', a: '可通过页面底部的「投稿爆料」入口提交线索。我们为爆料人提供严格的信息保护，所有投稿均采用端到端加密传输。对于重大独家爆料，我们将提供稿酬。' },
  { id: 'faq-3', q: '每日爆料的更新频率是怎样的？', a: '编辑团队实行 7×24 小时轮班制，确保重大突发事件 15 分钟内上线。常规内容每日至少更新 3 次，覆盖早间简报、午间更新和晚间汇总三个时段。' },
  { id: 'faq-4', q: '被爆料的内容不实怎么办？', a: '我们设有专门的纠错与申诉通道。如果当事人认为爆料内容与事实不符，可通过底部的联系入口提交证据材料，编辑团队将在 24 小时内核实并作出回应。' },
  { id: 'faq-5', q: '每日爆料与普通八卦账号有什么区别？', a: '核心区别在于信息验证和整理深度。我们不传播未经核实的谣言，每篇内容都会追溯信息源头。此外，我们提供事件时间线、人物关系图谱等结构化信息，让吃瓜变得更加理性和有趣。' },
];

export const carouselItems = [
  {
    id: 'cr-1',
    title: '2025 网红塌房大盘点',
    subtitle: '年度重磅专题',
    desc: '整理本年度最具影响力的网红翻车事件，从税务到人设，从法律到道德，完整复盘每一起事件的来龙去脉。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20red%20themed%20editorial%20composition%20with%20breaking%20news%20aesthetic%2C%20spotlight%20on%20a%20single%20figure%2C%20high%20contrast%20moody%20lighting%2C%20cinematic%20photography%20style%2C%20warm%20dark%20amber%20and%20crimson%20tones%2C%20grainy%20film%20texture&width=800&height=500&seq=cr-2025-01&orientation=landscape',
  },
  {
    id: 'cr-2',
    title: 'MCN 行业内幕深度调查',
    subtitle: '独家系列报道',
    desc: '深入探访头部 MCN 机构内部运作，揭示网红制造流水线的真实面貌，从业者匿名讲述行业内幕。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20with%20dramatic%20shadows%2C%20silhouette%20of%20person%20behind%20frosted%20glass%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20amber%20and%20charcoal%20tones%2C%20investigative%20journalism%20aesthetic&width=800&height=500&seq=cr-2025-02&orientation=landscape',
  },
  {
    id: 'cr-3',
    title: '直播带货避坑指南',
    subtitle: '消费者必读',
    desc: '收集整理直播间常见套路和话术陷阱，教你识破虚假促销、夸大宣传和伪劣产品，守护你的钱包。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20studio%20livestream%20setup%20with%20ring%20light%20and%20products%2C%20but%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere%2C%20contrast%20between%20glamour%20and%20reality%2C%20cinematic%20composition%2C%20warm%20golden%20and%20dark%20red%20tones&width=800&height=500&seq=cr-2025-03&orientation=landscape',
  },
  {
    id: 'cr-4',
    title: '网红移民潮全记录',
    subtitle: '现象级观察',
    desc: '多位头部网红陆续移居海外，背后原因分析：资产配置、子女教育还是风险规避？深度解密网红阶层迁徙。',
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20modern%20city%20skyline%20at%20sunset%2C%20airplane%20silhouette%2C%20moody%20atmospheric%20lighting%2C%20concept%20of%20migration%20and%20movement%2C%20warm%20golden%20and%20deep%20charcoal%20tones%2C%20editorial%20photography&width=800&height=500&seq=cr-2025-04&orientation=landscape',
  },
  {
    id: 'cr-5',
    title: '从素人到顶流：网红成长史',
    subtitle: '人物深度专题',
    desc: '选取 5 位从零起步成长到千万粉丝的网红，拆解他们的内容策略、人设打造和变现路径，揭示成功背后的关键抉择。',
    image: 'https://readdy.ai/api/search-image?query=Single%20spotlight%20on%20empty%20stage%20with%20microphone%20stand%2C%20dramatic%20theater%20lighting%2C%20concept%20of%20fame%20and%20journey%2C%20warm%20amber%20spotlight%20against%20dark%20background%2C%20cinematic%20moody%20aesthetic&width=800&height=500&seq=cr-2025-05&orientation=landscape',
  },
  {
    id: 'cr-6',
    title: 'AI 虚拟网红来袭',
    subtitle: '行业趋势前瞻',
    desc: '当 AI 生成的虚拟网红开始抢夺真人网红的市场份额，这个行业将何去何从？盘点当前主流虚拟网红和背后技术。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20avatar%20with%20glitch%20effects%20and%20holographic%20texture%2C%20dark%20tech%20aesthetic%2C%20contrast%20between%20human%20and%20artificial%2C%20cyberpunk%20inspired%20with%20warm%20amber%20accents%2C%20cinematic%20composition&width=800&height=500&seq=cr-2025-06&orientation=landscape',
  },
];

export const featuresItems = [
  { id: 'fe-1', icon: 'ri-timer-flash-line', title: '极速追踪', desc: '7×24 小时全平台监控，重大事件 15 分钟内上线，比热搜还快。编辑团队轮班值守，确保你不漏掉任何一个大瓜。' },
  { id: 'fe-2', icon: 'ri-shield-check-line', title: '信源可溯', desc: '每条爆料标注信息来源和可信度等级，让你吃得明明白白。不传谣、不造谣，只做有据可查的网红圈记录。' },
  { id: 'fe-3', icon: 'ri-file-list-3-line', title: '深度整理', desc: '不止碎片化八卦，更有事件时间线、人物关系图谱和深度分析文章。把散落的信息连成完整的故事。' },
];

export const cardsItems = [
  {
    id: 'cd-1',
    title: '某千万粉网红偷税被罚 1.08 亿',
    desc: '税务部门公布最新网络主播偷逃税案例，涉及头部直播带货主播。该主播名下多家公司存在虚假申报行为，目前已补缴税款及罚款合计过亿。',
    badge: '重磅',
    image: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20with%20documents%20and%20tax%20forms%20on%20desk%2C%20dramatic%20lighting%2C%20serious%20legal%20atmosphere%2C%20warm%20amber%20and%20dark%20red%20tones%2C%20editorial%20news%20photography&width=800&height=500&seq=cd-2025-01&orientation=landscape',
  },
  {
    id: 'cd-2',
    title: '恋爱综艺网红人设前后对比',
    desc: '某恋爱综艺走红的多位网红被扒出节目人设与现实严重不符，从学历到家境到感情经历均存在造假嫌疑，粉丝集体脱粉。',
    badge: '热议',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20composition%20showing%20contrast%20between%20glamorous%20TV%20set%20and%20ordinary%20real%20life%2C%20dramatic%20reveal%20concept%2C%20warm%20and%20dark%20contrasting%20lighting%2C%20editorial%20style&width=800&height=500&seq=cd-2025-02&orientation=landscape',
  },
  {
    id: 'cd-3',
    title: 'MCN 老板群内威胁达人聊天记录曝光',
    desc: '某中腰部 MCN 机构创始人微信群内对旗下达人发出威胁言论，声称"不续约就全网封杀你"，相关截图已获多方证实。',
    badge: '独家',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20smartphone%20screen%20showing%20chat%20messages%20with%20dramatic%20red%20light%20reflection%2C%20dark%20atmosphere%2C%20concept%20of%20digital%20threat%2C%20cinematic%20moody%20lighting%2C%20investigative%20journalism%20aesthetic&width=800&height=500&seq=cd-2025-03&orientation=landscape',
  },
  {
    id: 'cd-4',
    title: '探店博主恶意差评产业链被起底',
    desc: '调查发现部分探店博主以差评为威胁向商家收取"保护费"，不给钱的商家会收到有组织的恶意低分攻击，已涉及数百家餐饮店铺。',
    badge: '调查',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20restaurant%20interior%20with%20empty%20tables%2C%20single%20spotlight%2C%20rating%20stars%20concept%2C%20dramatic%20shadows%2C%20investigative%20atmosphere%2C%20warm%20amber%20and%20deep%20charcoal%20tones&width=800&height=500&seq=cd-2025-04&orientation=landscape',
  },
  {
    id: 'cd-5',
    title: '游戏主播代打产业链年入过亿',
    desc: '深度调查游戏直播代打黑产：头部主播直播时露脸的背后，实际操作者另有其人。代打人员按小时计费，高段位代打月入可达六位数。',
    badge: '深度',
    image: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20multiple%20monitors%20in%20dark%20room%2C%20silhouette%20of%20person%20at%20desk%2C%20mysterious%20gaming%20atmosphere%2C%20neon%20red%20and%20amber%20accents%2C%20cinematic%20composition%2C%20investigative%20theme&width=800&height=500&seq=cd-2025-05&orientation=landscape',
  },
];

export const mediaItems = [
  {
    id: 'md-1',
    title: '独家对话：前 MCN 运营总监揭秘行业内幕',
    duration: '45:22',
    views: '89.2万',
    image: 'https://readdy.ai/api/search-image?query=Interview%20setup%20with%20silhouette%20of%20person%20against%20bright%20window%2C%20anonymous%20whistleblower%20concept%2C%20dramatic%20backlight%2C%20cinematic%20documentary%20style%2C%20warm%20golden%20light%20and%20dark%20shadows&width=800&height=450&seq=md-2025-01&orientation=landscape',
  },
  {
    id: 'md-2',
    title: '网红翻车名场面合集：2025 上半年',
    duration: '18:09',
    views: '156.7万',
    image: 'https://readdy.ai/api/search-image?query=Collage%20of%20multiple%20dramatic%20TV%20screens%20showing%20different%20scenes%2C%20glitch%20effect%2C%20media%20wall%20concept%2C%20warm%20red%20and%20amber%20tones%2C%20cinematic%20broadcast%20aesthetic&width=800&height=450&seq=md-2025-02&orientation=landscape',
  },
  {
    id: 'md-3',
    title: '数据解读：网红经济 2025 半年报',
    duration: '32:41',
    views: '67.3万',
    image: 'https://readdy.ai/api/search-image?query=Data%20visualization%20dashboard%20with%20charts%20and%20graphs%20on%20dark%20background%2C%20glowing%20amber%20data%20lines%2C%20modern%20financial%20analysis%20aesthetic%2C%20cinematic%20tech%20atmosphere&width=800&height=450&seq=md-2025-03&orientation=landscape',
  },
];

export const topicsItems = [
  { id: 'tp-1', name: '直播翻车', count: '12.8万讨论', hot: true },
  { id: 'tp-2', name: 'MCN 内幕', count: '9.6万讨论', hot: true },
  { id: 'tp-3', name: '人设崩塌', count: '8.3万讨论', hot: true },
  { id: 'tp-4', name: '偷税漏税', count: '7.1万讨论', hot: false },
  { id: 'tp-5', name: '网红恋情', count: '6.5万讨论', hot: false },
  { id: 'tp-6', name: '带货翻车', count: '5.9万讨论', hot: false },
  { id: 'tp-7', name: '整容对比', count: '5.2万讨论', hot: false },
  { id: 'tp-8', name: '合同纠纷', count: '4.8万讨论', hot: false },
  { id: 'tp-9', name: '学历造假', count: '4.1万讨论', hot: false },
  { id: 'tp-10', name: 'AI 虚拟网红', count: '3.6万讨论', hot: true },
];

export const contactContent = {
  title: '投稿爆料',
  subtitle: '你有料，我来爆',
  desc: '如果你掌握网红圈一手信息或独家线索，欢迎通过以下方式联系我们。所有爆料人均受严格的信息保护，重大独家线索将获得稿酬回报。',
  email: 'tips@meiribaoliao.com',
  wechat: 'mrbl_tips',
  hint: '请尽量提供可验证的证据材料，如截图、录音、合同等。我们会在收到线索后 24 小时内响应。',
};